const getServiceToReceiptStatus = `getClosingStatusPayrollPeriod{servicesToReceipts}`;

export default getServiceToReceiptStatus;
